// ** Styles
import '@styles/react/apps/app-roads.scss';
import Wizard from '../shared/Wizard';

const defaultValues = {
  name: '',
  description: '',
  status: 'initial',
  membership: 'initial',
  cover: '',
  episodes: [],
  new: true,
  disable: false,
  challenge:false
};

const NewEpisode = () => {
  return <Wizard editMode={false} defaultValues={defaultValues} />;
};

export default NewEpisode;
